import RedirectRulesFA from './fa/fa.json'

const RedirectRulesMessages = {
  fa: { ...RedirectRulesFA },
}

export default RedirectRulesMessages
